import { Typography } from 'components/generic/typography';
import Layout from 'components/Layout';
import type { IHeadline } from '../../../../../shared/productList/shared/types';

export default function HeadlineHeader({ model }: { model: IHeadline }): JSX.Element {
    const { name } = model;

    return (
        <Layout.Section>
            <Typography.Headline as="h1" size="L">
                {name}
            </Typography.Headline>
        </Layout.Section>
    );
}
